import ReactLightbox from 'react-image-lightbox';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
const Lightbox = ({
  style: _style = {
    width: '100%',
    marginBottom: '0px'
  },
  images,
  selectedIndex,
  enableZoom: _enableZoom = false
}) => {
  const [lightboxVisible, toggleLightbox] = useState(false);
  const [index, setIndex] = useState(selectedIndex);
  const displayLightbox = () => {
    toggleLightbox(!lightboxVisible);
    setIndex(selectedIndex); // always reset the index to selected on open/close
  };
  const calculateIndex = direction => (index + images.length + direction) % images.length;
  return /*#__PURE__*/React.createElement("div", null, lightboxVisible ? /*#__PURE__*/React.createElement(ReactLightbox, {
    mainSrc: images[index],
    nextSrc: images.length > 1 ? images[calculateIndex(+1)] : null,
    prevSrc: images.length > 1 ? images[calculateIndex(-1)] : null,
    onMoveNextRequest: () => setIndex(calculateIndex(+1)),
    onMovePrevRequest: () => setIndex(calculateIndex(-1)),
    onCloseRequest: displayLightbox,
    animationOnKeyInput: true // animate transition when using arrows
    ,
    reactModalStyle: {
      overlay: {
        zIndex: 2000
      }
    } // footer is 1030
    ,
    enableZoom: _enableZoom
  }) : '', /*#__PURE__*/React.createElement("div", {
    tabIndex: "0",
    role: "button",
    onClick: displayLightbox,
    onKeyPress: displayLightbox,
    className: `t-lightbox-${selectedIndex}`
  }, /*#__PURE__*/React.createElement("img", {
    alt: "img",
    src: images[selectedIndex],
    style: _style,
    className: `t-thumbnail-${selectedIndex}`
  })));
};
Lightbox.propTypes = {
  selectedIndex: PropTypes.number.isRequired,
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  style: PropTypes.shape({}),
  enableZoom: PropTypes.bool
};
export default Lightbox;